export default (state, checkin) => {
  state.loggedin.checkin = checkin;
}


// WEBPACK FOOTER //
// ./src/app/store/users/mutations/set-checkin-mode.js